import React from "react";
import { Thermometer, ShieldCheck, RefreshCw, Droplets } from "lucide-react";
import { Card } from "@/components/ui/card";
const advantagesData = [{
  title: "Reciclaje de Acero",
  description: "Transformamos chatarra ferrosa en acero de alta calidad, reduciendo la necesidad de minería extractiva y disminuyendo significativamente la huella de carbono en la industria de la construcción.",
  icon: RefreshCw
}, {
  title: "Eficiencia Energética",
  description: "Implementamos procesos de fundición optimizados que minimizan el consumo eléctrico y aprovechan el calor residual, garantizando una producción industrial responsable con el medio ambiente.",
  icon: Thermometer
}, {
  title: "Gestión de Residuos",
  description: "Contamos con protocolos estrictos para el manejo de subproductos industriales, asegurando que cada residuo sea procesado o reutilizado bajo las normativas ambientales más exigentes.",
  icon: ShieldCheck
}, {
  title: "Cuidado del Agua",
  description: "Nuestras plantas operan con sistemas de circuito cerrado para el tratamiento y reutilización del agua, eliminando vertidos contaminantes y preservando este recurso vital para la comunidad.",
  icon: Droplets
}];
export default function PrCticasDeSostenibilidad() {
  return <section data-section-id="255618" id="prácticas-de-sostenibilidad" className="py-16 md:py-24 bg-muted text-foreground">
      <div className="container mx-auto px-4 md:px-6 max-w-[1280px]">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-[32px] font-bold font-default text-foreground mb-4">
            Compromiso con la Sostenibilidad
          </h2>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {advantagesData.map((adv, i) => <Card key={i} data-index={i} className="p-6 shadow-md hover:shadow-lg transition-all duration-300 border border-border bg-card rounded-lg group">
              <div className="flex flex-col sm:flex-row gap-5 items-start">
                <div className="shrink-0 flex items-center justify-center w-14 h-14 rounded-lg bg-primary-100 text-primary transition-transform duration-300 group-hover:scale-110">
                  <adv.icon className="w-7 h-7" strokeWidth={1.5} />
                </div>
                <div>
                  <h3 className="text-xl md:text-[32px] font-semibold font-default text-card-foreground mb-2">
                    {adv.title}
                  </h3>
                  <p className="text-muted-foreground font-default leading-relaxed text-sm md:text-base">
                    {adv.description}
                  </p>
                </div>
              </div>
            </Card>)}
        </div>
      </div>
    </section>;
}